/* Riposte — fiche produit : pastilles de couleur + barre d'achat mobile */
(function () {
  'use strict';

  var root = document.querySelector('[data-rpp]');
  if (!root) return;

  /* ---------- pastilles de couleur ---------- */
  var swatches = Array.prototype.slice.call(root.querySelectorAll('[data-rpp-sw]'));
  var idInput = root.querySelector('[data-rpp-id]');
  var priceEl = root.querySelector('[data-rpp-price]');
  var nameEl = root.querySelector('[data-rpp-swname]');
  var cta = root.querySelector('.rpp__form .rpp__cta');
  var barPrice = root.querySelector('.rpp__bar-price');
  var shots = Array.prototype.slice.call(root.querySelectorAll('[data-rpp-media]'));

  // Le prix barré de chaque variante est écrit dans la page par le Liquid
  // ([data-rpp-was]) ; on n'affiche que celui de la variante choisie.
  var wases = Array.prototype.slice.call(root.querySelectorAll('[data-rpp-was]'));
  function showWas(id) {
    wases.forEach(function (w) { w.style.display = w.getAttribute('data-rpp-was') === String(id) ? '' : 'none'; });
  }

  // « Crème », « creme », « CRÈME » doivent tous correspondre.
  function norm(str) {
    return (str || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  // Une valeur d'option peut être saisie « Noir » ou « Raquette de padel
  // Riposte Ronde, coloris Noir ». On retient les deux formes : la chaîne
  // entière, et son dernier mot, qui est le nom de la couleur.
  function tokensFor(raw) {
    var full = norm(raw);
    if (!full) return [];
    var parts = full.split(' ');
    var last = parts[parts.length - 1];
    return last && last !== full ? [full, last] : [full];
  }

  var colorTokens = swatches.map(function (b) {
    return tokensFor(b.getAttribute('data-color'));
  });

  function taggedWith(fig, tokens) {
    var alt = norm(fig.getAttribute('data-color'));
    return tokens.some(function (t) { return t && alt.indexOf(t) !== -1; });
  }

  function filterGallery(color) {
    if (!shots.length) return;
    var mine = tokensFor(color);
    if (!mine.length) return;

    shots.forEach(function (fig) {
      var isMine = taggedWith(fig, mine);
      var namesAColor = colorTokens.some(function (t) { return taggedWith(fig, t); });
      // Une image qui ne nomme AUCUN coloris est neutre — macro matière,
      // schéma technique, bandeau de réassurance. Elle reste toujours
      // visible. On ne masque que ce qui revendique une autre couleur.
      fig.hidden = namesAColor && !isMine;
    });

    syncCarousel();
  }

  function select(btn) {
    var available = btn.getAttribute('data-available') === 'true';

    swatches.forEach(function (b) {
      b.classList.toggle('rpp__sw-dot--on', b === btn);
      b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
    });

    if (idInput) idInput.value = btn.getAttribute('data-id');
    if (priceEl) priceEl.textContent = btn.getAttribute('data-price');
    if (barPrice) barPrice.textContent = btn.getAttribute('data-price');
    if (nameEl) nameEl.textContent = btn.getAttribute('data-name');
    showWas(btn.getAttribute('data-id'));

    if (cta) {
      cta.disabled = !available;
      cta.textContent = available ? cta.getAttribute('data-label') || cta.textContent : 'Bientôt de retour';
    }

    filterGallery(btn.getAttribute('data-color'));
  }

  if (swatches.length) {
    if (cta && !cta.getAttribute('data-label')) {
      cta.setAttribute('data-label', cta.textContent.trim());
    }
    swatches.forEach(function (btn) {
      btn.addEventListener('click', function () { select(btn); });
    });
  }

  /* ---------- carrousel ---------- */
  var track = root.querySelector('[data-rpp-track]');
  var dots = Array.prototype.slice.call(root.querySelectorAll('[data-rpp-dot]'));
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-rpp-thumb]'));
  var prev = root.querySelector('[data-rpp-prev]');
  var next = root.querySelector('[data-rpp-next]');

  function visible() {
    return shots.filter(function (f) { return !f.hidden; });
  }

  function goTo(fig) {
    if (!track || !fig) return;
    // scrollIntoView emporterait la page entière avec lui : on ne déplace
    // que la piste, en calculant le décalage nous-mêmes.
    track.scrollTo({ left: fig.offsetLeft - track.offsetLeft, behavior: 'smooth' });
  }

  function markActive(i) {
    dots.forEach(function (d) {
      var on = d.getAttribute('data-i') === String(i);
      d.classList.toggle('rpp__gdot--on', on);
      d.setAttribute('aria-current', on ? 'true' : 'false');
    });
    thumbs.forEach(function (t) {
      t.classList.toggle('rpp__thumb--on', t.getAttribute('data-i') === String(i));
    });
  }

  // Les repères et miniatures des photos filtrées disparaissent avec elles :
  // sans ça, cliquer sur le troisième point ne mènerait nulle part.
  function syncCarousel() {
    if (!track) return;
    var shown = {};
    shots.forEach(function (f) { shown[f.getAttribute('data-i')] = !f.hidden; });
    dots.concat(thumbs).forEach(function (el) {
      el.hidden = !shown[el.getAttribute('data-i')];
    });
    var first = visible()[0];
    if (first) {
      track.scrollLeft = 0;
      markActive(first.getAttribute('data-i'));
    }
    var many = visible().length > 1;
    if (prev) prev.disabled = !many;
    if (next) next.disabled = !many;
  }

  if (track) {
    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        goTo(shots[Number(d.getAttribute('data-i'))]);
      });
    });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        goTo(shots[Number(t.getAttribute('data-i'))]);
      });
    });

    function step(dir) {
      var vis = visible();
      var w = track.clientWidth;
      var at = Math.round(track.scrollLeft / w);
      var to = Math.min(Math.max(at + dir, 0), vis.length - 1);
      goTo(vis[to]);
    }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting && e.intersectionRatio > 0.55) {
            markActive(e.target.getAttribute('data-i'));
          }
        });
      }, { root: track, threshold: [0.55] });
      shots.forEach(function (f) { io.observe(f); });
    }

    syncCarousel();
  }

  // Filtrage initial en dernier : il appelle syncCarousel(), qui a besoin
  // que la piste et les repères soient déjà connus. Appelé plus haut, il
  // ne faisait rien — et ne fonctionnait que par l'ordre des lignes.
  var current = root.querySelector('.rpp__sw-dot--on');
  if (current) filterGallery(current.getAttribute('data-color'));

  /* ---------- barre d'achat mobile ---------- */
  var bar = root.querySelector('[data-rpp-bar]');
  if (!bar || !cta || !('IntersectionObserver' in window)) return;

  bar.hidden = false;

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (e) {
        bar.classList.toggle('rpp__bar--on', !e.isIntersecting && e.boundingClientRect.top < 0);
      });
    },
    { threshold: 0 }
  );
  io.observe(cta);
})();
